import { NgModule } from '@angular/core';

import { UserMutationService } from './user-mutation.service';
import { UserService } from './user.service';

@NgModule({
  providers: [UserMutationService, UserService],
})
export class UserModule {}
